import React, {Component} from "react"
import {connect} from "react-redux"
import {translate} from "react-i18next"
import {push} from "redux-little-router"

import PropTypes from "prop-types"

import {Col} from "../Grid"
import Button from "../../components/Button"
import {Link} from "redux-little-router"
import {vars} from "../../config"
import env from "../../env"
import {otherLanguages} from "../../utils"

import styles from "./styles.css"

import flag_de from "../../assets/icons/flag_de.svg"
import flag_en from "../../assets/icons/flag_en.svg"

class LangSwitch extends Component {
  constructor() {
    super()
    this._toggleLangModal = this._toggleLangModal.bind(this)
    this._initLangSelect = this._initLangSelect.bind(this)
    this.langModal = React.createRef()
    this.flags = {
      de: flag_de,
      en: flag_en
    }

    this.state = {
      active: false,
      selectedLang: null
    }
  }

  static propTypes = {
    // slug: PropTypes.string,
    langurl: PropTypes.string
  }

  static defaultProps = {
    // slug: "",
    langurl: ""
  }

  _toggleLangModal(selectedLang) {
    this.setState(prevState => {
      return {
        ...prevState,
        active: !prevState.active,
        selectedLang
      }
    })
  }
  _initLangSelect(e) {
    window.location.href = e.target.value
    // this.props.push(e.target.value)
  }
  _isBlankUrl(url) {
    return url.substr(url.length - 4) === "null"
  }
  _getChildElement(lang, url, nodeType) {
    if (nodeType === "li") {
      return (
        <li className={lang} key={`lang-${lang}`}>
          <img src={this.flags[lang]} alt={vars.languages[lang]} />
          <a
            onClick={() => {
              if (this._isBlankUrl(url)) {
                this._toggleLangModal(lang)
              } else {
                this.props.push(url)
              }
            }}
          >
            {vars.languages[lang]}
          </a>
        </li>
      )
    } else if (nodeType === "option") {
      return (
        <option value={lang} key={`lang-option-${lang}`}>
          {vars.languages[lang]}
        </option>
      )
    }
  }

  render() {
    const {lang, langurl, t} = this.props

    // hide langswitch
    if (typeof env.HIDE_LANGSWITCH !== "undefined" && env.HIDE_LANGSWITCH)
      return <Col className={`${styles.Langswitch} lang-switch`} md={3} />

    return (
      <Col className={`${styles.Langswitch} lang-switch`} md={3}>
        {/* desktop */}
        <ul className="desktop">
          <li className={lang}>
            <img src={this.flags[lang]} alt={vars.languages[lang]} />
            <span>{vars.languages[lang]}</span>
            <div className="inner">
              <ul>
                {Object.keys(otherLanguages(lang)).map(l =>
                  this._getChildElement(l, langurl, "li")
                )}
              </ul>
            </div>
          </li>
        </ul>
        {/* mobile */}
        <select
          className="mobile"
          style={{backgroundImage: `url(${this.flags[lang]})`}}
          onChange={this._initLangSelect}
          defaultValue={`${this.props.lang === "de" ? "Deutsch" : "English"}`}
        >
          <option disabled hidden>
            {vars.languages[lang]}
          </option>
          {Object.keys(otherLanguages(lang)).map(l =>
            this._getChildElement(l, langurl, "option")
          )}
        </select>
        {/* modal */}
        <div
          className={`lang-modal ${this.state.active ? "is-active" : ""}`}
          ref={this.langModal}
        >
          <div className="inner">
            <p>
              {t(
                "Dieser Inhalt ist in der gewünschten Sprache nicht verfügbar."
              )}
            </p>
            <div className="buttons">
              <div className="button  button--dark button--medium button--inline button--default">
                <Link
                  onClick={this._toggleLangModal}
                  href={`/${this.state.selectedLang}/`}
                >
                  {t("Zur Startseite")}
                  <i className="button__icon icon--default" />
                </Link>
              </div>
              <Button onClick={this._toggleLangModal} theme="dark">
                {t("Schließen")}
              </Button>
            </div>
          </div>
        </div>
      </Col>
    )
  }
}

const mapStateToProps = state => {
  return {
    lang: state.app.lang,
    langurl: state.langswitch.langurl.langurl
  }
}

const mapDispatchToProps = dispatch => {
  return {
    push: location => dispatch(push(location))
  }
}

LangSwitch = connect(
  mapStateToProps,
  mapDispatchToProps
)(LangSwitch)
export default translate()(LangSwitch)



// WEBPACK FOOTER //
// ./src/components/LangSwitch/index.js